<template>
	<div class="list-container column">
		<div class="title">{{ $t('ongoing_moves.title') }}</div>
		<div class="panel-list-header">
			<div class="panel-header-item">{{ $t('ongoing_moves.from_customer') }}</div>
			<div class="panel-header-item">{{ $t('ongoing_moves.to_customer') }}</div>
			<div class="panel-header-item">{{ $t('ongoing_moves.building_count') }}</div>
			<div class="panel-header-item">{{ $t('ongoing_moves.status') }}</div>
			<div class="panel-filler" />
			<div class="panel-filler" />
		</div>
		<div
			class="panel-list"
			v-for="move in moves"
			:key="move.id"
			@click.stop="onEdit(move)"
		>
			<p class="panel-list-item">{{ move.fromCustomerName }}</p>
			<p class="panel-list-item">
				{{ move.targetCustomerName || "-" }}
			</p>
			<p class="panel-list-item" v-if="!isMobile">
				{{ move.moveBuildings.length }}
			</p>
			<p class="panel-list-item" v-if="!isMobile">
				{{ moveStatus(move) }}
			</p>
			<div class="list-button" @click.stop="onEdit(move)">
				<i class="fas fa-edit"></i>
			</div>
			<div class="list-button" @click.stop="onDelete(move)">
				<i class="fas fa-trash-alt"></i>
			</div>
		</div>
		<div class="panel-list no-hover" v-if="moves.length == 0">
			<p class="header-item">{{ $t('ongoing_moves.no_results') }}</p>
		</div>
		<Pagination
			v-if="moves.length > 0"
			:pagination="pagination"
			@paginate="paginate"
			@updatePageSize="updatePageSize"
		/>
	</div>
</template>

<script>
import Pagination from '@/components/Pagination';
import { mapGetters } from 'vuex';

export default {
	components: {
		Pagination
	},

	props: {
		moves: Array,
		pagination: Object
	},

	computed: {
		...mapGetters('appStore', ['isMobile'])
	},

	methods: {
		onDelete(move) {
			this.$emit('delete', move);
		},
		onEdit(move) {
			this.$emit('edit', move);
		},
		paginate(page) {
			this.$emit('paginate', page);
		},
		updatePageSize(size) {
			this.$emit('paginate', 1, size);
		},
		moveStatus(move) {
			switch (move.moveStatus) {
				case 0:
					return this.$t('ongoing_moves.status_open');
				case 1:
					return this.$t('ongoing_moves.status_started');
				case 2:
					return this.$t('ongoing_moves.status_completed');
			}
			return '';
		}
	}
};
</script>
